<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="isPartner ? ((incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.materieleVasteActiva?.at(0)?.waardeSlot ?? null) === null : ((incomeTaxEntity$ | async)?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.materieleVasteActiva?.at(0)?.waardeSlot ?? null) === null"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="lg"
                                title="Specificatie gebouwen en terreinen in eigen gebruik">
    <snelstart-ui-dialog-header-content>
        Vul onderstaand de waardes in voor de balanspost(en) per einde van het boekjaar.
    </snelstart-ui-dialog-header-content>
    <snelstart-ui-dialog-body>
        <form (change)="saveForm()" [formGroup]="formGroup">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="me-1 custom-input-250"
                                              formControlName="aanschafWaarde"
                                              label="Aanschafwaarde"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-250"
                                              formControlName="restWaarde"
                                              label="Restwaarde"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-250"
                                              formControlName="bodemwaarde"
                                              label="Bodemwaarde"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <div class="pt-2">
                <snelstart-ui-alert type="info">
                    Voor gebouwen in eigen gebruik is de <b>bodemwaarde</b> 50% van de WOZ-waarde. Per 1 januari 2024 is
                    dat 100% van de WOZ-waarde.
                    Voor gebouwen die je verhuurt (gebouwen ter belegging) is dat 100% van de WOZ-waarde.
                </snelstart-ui-alert>
            </div>
        </form>
    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button [disabled]="formGroup.invalid" icon="check" id="save" type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
